/**
 * Owlbert asset registry.
 *
 * Four illustrated Owlbert variants (with face). Pick the variant that
 * contrasts best with the surface it sits on:
 *   - main   : indigo owl on cream        → light/paper surfaces (client portal)
 *   - accent : light owl on solid indigo   → dark surfaces (operator dashboard)
 *   - black  : white owl on black          → high-contrast dark surfaces
 *   - white  : black owl on white          → high-contrast light surfaces
 *
 * Use `.owlbert-portrait` for the standard rounded avatar treatment.
 */
export const OWLBERT_MAIN = "/owlbert/main.png";
export const OWLBERT_ACCENT = "/owlbert/accent.png";
export const OWLBERT_BLACK = "/owlbert/black.png";
export const OWLBERT_WHITE = "/owlbert/white.png";

// Default face for dark neumorphic operator surfaces
export const OWLBERT_DARK = OWLBERT_BLACK;

// Default face for light portal surfaces
export const OWLBERT_LIGHT = OWLBERT_MAIN;
